import { jwtDecode } from 'jwt-decode';
import { logout } from '../redux/userSlice';

let autoLogoutTimeoutId = null;

export const isTokenExpired = (token) => {
  if (!token) return true;

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decoded.exp < currentTime;
  } catch (err) {
    return true;
  }
};

export const clearAutoLogout = () => {
  if (autoLogoutTimeoutId) {
    clearTimeout(autoLogoutTimeoutId);
    autoLogoutTimeoutId = null;
  }
};

export const setupAutoLogout = (store, token) => {
  clearAutoLogout();

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now();
    const expiryTime = decoded.exp * 1000;
    const timeout = expiryTime - currentTime;

    if (timeout > 0) {
      autoLogoutTimeoutId = setTimeout(() => {
        store.dispatch(logout());
        localStorage.removeItem('token');
        alert('Your session has expired. Please log in again.');
        window.location.href = '/signin';
      }, timeout);
    }
  } catch (err) {
    console.error('Failed to decode token for auto-logout', err);
  }
};
